import listAction from "./listAction.filter";

const listActionModule = angular
  .module("app.filters.listAction", [])
  .filter("listAction", listAction);

export default listActionModule;



// WEBPACK FOOTER //
// ./src/filters/listAction/listAction.module.js